import { Chip } from '@mui/material';
import {
    List,
    DataTable,
    TextField,
    TextInput,
    SelectInput,
    TopToolbar,
    FilterButton,
    ColumnsButton,
    ExportButton,
    EditButton,
    useRecordContext,
} from 'react-admin';
import {
    REPORT_REASON_CHOICES,
    REPORT_RISK_CHOICES,
    REPORT_STATUS_CHOICES,
} from './constants';
import { AiReportRecord } from './types';

const AiReportListActions = () => (
    <TopToolbar>
        <FilterButton />
        <ColumnsButton />
        <ExportButton />
    </TopToolbar>
);

const RiskLevelField = () => {
    const record = useRecordContext<AiReportRecord>();
    if (!record) return null;

    const colorByRisk: Record<string, 'default' | 'error' | 'warning' | 'success'> = {
        P0: 'error',
        P1: 'warning',
        P2: 'default',
        P3: 'success',
    };

    return <Chip label={record.risk_level} color={colorByRisk[record.risk_level] || 'default'} size="small" />;
};

const StatusField = () => {
    const record = useRecordContext<AiReportRecord>();
    if (!record) return null;
    return <Chip label={record.status} color="primary" size="small" variant="outlined" />;
};

const Column = DataTable.Col<AiReportRecord>;

const AiReportList = () => {
    const filters = [
        <SelectInput key="status" label="Status" source="status" choices={REPORT_STATUS_CHOICES} alwaysOn />,
        <SelectInput key="riskLevel" label="Risk" source="riskLevel" choices={REPORT_RISK_CHOICES} />,
        <SelectInput key="reasonCode" label="Reason" source="reasonCode" choices={REPORT_REASON_CHOICES} />,
        <TextInput key="modelVersion" label="Model Version" source="modelVersion" />,
    ];

    return (
        <List
            filters={filters}
            actions={<AiReportListActions />}
            perPage={25}
            sort={{ field: 'created_at', order: 'DESC' }}
        >
            <DataTable rowClick="edit" bulkActionButtons={false}>
                <Column source="report_id" label="Report ID">
                    <TextField source="report_id" />
                </Column>
                <Column source="user_id" label="User ID">
                    <TextField source="user_id" />
                </Column>
                <Column source="reason_code" label="Reason">
                    <TextField source="reason_code" />
                </Column>
                <Column source="risk_level" label="Risk">
                    <RiskLevelField />
                </Column>
                <Column source="status" label="Status">
                    <StatusField />
                </Column>
                <Column source="model_version" label="Model Version">
                    <TextField source="model_version" />
                </Column>
                <Column source="created_at" label="Created At">
                    <TextField source="created_at" />
                </Column>
                <Column>
                    <EditButton />
                </Column>
            </DataTable>
        </List>
    );
};

export default AiReportList;
